import { Chain } from 'viem';
import { addChain } from 'viem/actions';
import { getWalletClient } from '@wagmi/core';
import { t } from '@ankr.com/common';

import { web3Api } from 'store/queries';
import { wagmiConfig } from 'modules/api/web3/appKit';
import { extractViemErrorMessage } from 'modules/api/web3/utils/extractViemErrorMessage';
import { getQueryWithErrorNotification } from 'store/utils/getQueryWithErrorNotification';

import { hasMetamask } from '../utils/hasMetamask';

export interface AddNetworkParams {
  chain: IChainParams;
}

export interface IChainParams extends Chain {}

export const {
  endpoints: { authAddNetwork },
  useLazyAuthAddNetworkQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    authAddNetwork: build.query<boolean, AddNetworkParams>({
      queryFn: getQueryWithErrorNotification(async ({ chain }) => {
        if (!hasMetamask()) {
          throw new Error(t('error.no-metamask'));
        }

        const client = await getWalletClient(wagmiConfig);

        try {
          await addChain(client, { chain });
        } catch (error) {
          throw new Error(
            extractViemErrorMessage(error, {
              networkName: chain.name,
              tokenName: chain.nativeCurrency.symbol,
            }),
            { cause: error },
          );
        }

        return { data: true };
      }),
    }),
  }),
});
